/** Figma's `popover/container/header/p`, in spacing steps. */
export const HEADER_PADDING = 1.5;

/** Figma's `popover/container/header/spacing`: title to subtitle. */
export const HEADER_GAP_PX = 10;

/** Figma's `popover/container/header/border` — the divider under the header. */
export const HEADER_BORDER_WIDTH_PX = 1;

/** Figma's close button: a 16px box flush with the header's padding (`button/medium/label/icon`). */
export const CLOSE_BOX_PX = 16;

/** Figma's `popover/container/header/label/spacing`: what the title keeps clear of the close glyph. */
export const HEADING_SPACING_PX = 8;

/** Figma's `popover/container/body/p`, in spacing steps. */
export const CONTENT_PADDING = 1.5;

export const TITLE_VARIANT = "subtitle1";

export const SUBTITLE_VARIANT = "body2";

export const DEFAULT_CLOSE_LABEL = "Close";
